// Shared operational queue: confirmation revision, never equipment-list length.
export const equipmentToday = (now = new Date()) => {
 const parts = new Intl.DateTimeFormat('en-NZ', {timeZone:'Pacific/Auckland',year:'numeric',month:'2-digit',day:'2-digit'}).formatToParts(now);
 const part = (type:string) => parts.find(p=>p.type===type)!.value;
 return `${part('year')}-${part('month')}-${part('day')}`;
};
const activeStages = ['APPROVED','WON','PRE_PRODUCTION','STAGING','LIVE_EVENT','LIVE','ONBOARDING','UPCOMING'];
const cancelledStages = ['CANCELLED','CANCELED','WITHDRAWN','ARCHIVED','LOST','REJECTED'];
export function equipmentConfirmationQueue(jobs:any[], shifts:any[], today=equipmentToday()) {
 const active = new Map(jobs.filter(job => job.type !== 'CONTACT' && activeStages.includes(String(job.stage || job.productionStage || job.salesStage || job.status || '').toUpperCase())).map(job=>[job.id,job]));
 return shifts.filter(shift => active.has(shift.lead_id)
   && !cancelledStages.includes(String(shift.status || '').toUpperCase())
   && !(Number(shift.equipment_revision) >= 1)
   && (!shift.event_date || String(shift.event_date).slice(0,10) >= today))
  .map(shift=>({job:active.get(shift.lead_id)!,shift,status:
    (Array.isArray(shift.equipment_list) && shift.equipment_list.length>0) || shift.equipment_seeded_at || shift.equipment_source_mode
      ? 'Equipment List Awaiting Confirmation' : 'Equipment Not Loaded'}))
  .sort((a,b)=>String(a.shift.event_date || '9999').localeCompare(String(b.shift.event_date || '9999')) || String(a.shift.shift_title).localeCompare(String(b.shift.shift_title)));
}
export function equipmentQueueLabel(queue:ReturnType<typeof equipmentConfirmationQueue>) {
 const jobs = new Set(queue.map(row=>row.job.id)).size;
 return `${queue.length} ${queue.length===1?'shift':'shifts'} awaiting equipment confirmation · ${jobs} ${jobs===1?'job':'jobs'}`;
}
